import { Path } from '@/main/router/routerPath';

import { HromadnaKorespondence } from './hromadnaKorespondence';
import { Zpravy } from './zpravy';
import List from './pages/LeadyList.vue';
import { CustomerLeads } from './CustomerLeads';
import { DanVerification } from './DanVerification';
import { VerificationHistory } from './VerificationHistory';
import { CustomerVerification } from './CustomerVerification';
import { DialogueMarketing } from '../ciselnik/DialogueMarketing';

export const router =	new Path('Crm').addChildren([
	new Path('Leady', { List }, 'CRM_Leady'),
	HromadnaKorespondence.router,
	Zpravy.router,
	CustomerLeads.router,
	DanVerification.router,
	VerificationHistory.router,
	CustomerVerification.router,
	DialogueMarketing.router,
]);
